/**
 * @flow
 * @relayHash 56ac0c364c5f443eada96e58278cc659
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AmountWithCurrencyFieldQueryVariables = {|
  currencyCode: string
|};
export type AmountWithCurrencyFieldQueryResponse = {|
  +currencyRate: ?{|
    +rateDate: ?any,
    +baseCurrency: ?string,
    +currencyCode: ?string,
    +rate: ?any,
  |}
|};
export type AmountWithCurrencyFieldQuery = {|
  variables: AmountWithCurrencyFieldQueryVariables,
  response: AmountWithCurrencyFieldQueryResponse,
|};
*/


/*
query AmountWithCurrencyFieldQuery(
  $currencyCode: String!
) {
  currencyRate(currencyCode: $currencyCode) {
    rateDate
    baseCurrency
    currencyCode
    rate
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "currencyCode",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "currencyRate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "currencyCode",
        "variableName": "currencyCode"
      }
    ],
    "concreteType": "ExchangeRateNode",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rateDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "baseCurrency",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "currencyCode",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rate",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AmountWithCurrencyFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AmountWithCurrencyFieldQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AmountWithCurrencyFieldQuery",
    "id": null,
    "text": "query AmountWithCurrencyFieldQuery(\n  $currencyCode: String!\n) {\n  currencyRate(currencyCode: $currencyCode) {\n    rateDate\n    baseCurrency\n    currencyCode\n    rate\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0a19ba829796ec81151faf4b284c7768';
module.exports = node;
